import { Link } from "react-router-dom";
import { MessageCircle, ShoppingBag } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { waGeneral } from "@/lib/whatsapp";

export const Logo = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-label="Kuki Impresiones">
    <rect width="64" height="64" rx="14" fill="#FFD027" stroke="#18181B" strokeWidth="3" />
    <path d="M22 15v34" stroke="#18181B" strokeWidth="7" strokeLinecap="round" />
    <path d="M42 17 26 32l16 15" stroke="#FF3E83" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

export const scrollToId = (id) => (e) => {
  e.preventDefault();
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
  else el.scrollIntoView({ behavior: "smooth" });
};

const links = [
  { label: "Catálogo", href: "#catalogo", testid: "nav-link-catalog" },
  { label: "Cómo Comprar", href: "#como-comprar", testid: "nav-link-policies" },
  { label: "Nosotros", href: "#nosotros", testid: "nav-link-about" },
];

export default function Navbar() {
  const { cartCount } = useStore();
  return (
    <header data-testid="main-navbar" className="fixed top-0 inset-x-0 z-50 bg-paper/95 backdrop-blur border-b-2 border-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-[72px] flex items-center justify-between gap-3">
        <a href="#inicio" onClick={scrollToId("#inicio")} className="flex items-center gap-3 shrink-0" data-testid="nav-logo">
          <Logo size={40} />
          <div className="leading-none">
            <span className="font-display font-bold text-xl tracking-tight block">Kuki</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink/70">Impresiones</span>
          </div>
        </a>
        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={scrollToId(l.href)} data-testid={l.testid}
              className="px-4 py-2 rounded-full font-semibold text-sm hover:bg-kyellow transition-colors duration-200">
              {l.label}
            </a>
          ))}
          <Link to="/admin" data-testid="nav-link-admin"
            className="px-4 py-2 rounded-full font-semibold text-sm hover:bg-kcyan/40 transition-colors duration-200">
            Admin
          </Link>
        </nav>
        <div className="flex items-center gap-2">
          <a href="#pedido" onClick={scrollToId("#pedido")} data-testid="nav-cart-btn"
            className="relative h-11 w-11 grid place-items-center rounded-full border-2 border-ink bg-white shadow-neo-sm hover:-translate-y-0.5 transition-transform duration-200">
            <ShoppingBag size={20} strokeWidth={2.5} />
            {cartCount > 0 && (
              <span data-testid="nav-cart-count" className="absolute -top-1.5 -right-1.5 bg-kpink text-white text-xs font-bold h-5 min-w-5 px-1 rounded-full grid place-items-center border-2 border-ink">
                {cartCount}
              </span>
            )}
          </a>
          <a href={waGeneral()} target="_blank" rel="noopener noreferrer" data-testid="nav-whatsapp-cta"
            className="h-11 px-4 hidden sm:flex items-center gap-2 rounded-full border-2 border-ink bg-[#25D366] text-white font-bold text-sm shadow-neo-sm hover:-translate-y-0.5 transition-transform duration-200">
            <MessageCircle size={18} strokeWidth={2.5} />
            <span className="hidden lg:inline">WhatsApp</span>
          </a>
        </div>
      </div>
    </header>
  );
}
